import { render } from "./Behandeling.vue?vue&type=template&id=7f1f0c9e&scoped=true"
const script = {}

import "./Behandeling.vue?vue&type=style&index=0&id=7f1f0c9e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\reino\\Desktop\\testt\\de-tol\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1f0c9e"]])

export default __exports__